<script setup>
  import { ref, computed, watchEffect } from 'vue';

  const props = defineProps({
    id: {
      type: String,
      required: true
    },
    drawingManager: {
      type: Object,
      required: true
    },
    points: {
      type: Array,
      required: true
    },
    strokeColor: {
      type: String,
      default: '#FF0000'
    },
    strokeOpacity: {
      type: Number,
      default: 1.0
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  });

  const strokeColor = ref(props.strokeColor);
  const strokeOpacity = ref(props.strokeOpacity);
  const strokeWidth = ref(props.strokeWidth);

  const points = computed(() => {
    return props.points
      .map((point) => `${point.x},${point.y}`)
      .join(' ')
  });

  watchEffect(() => {
    strokeColor.value = props.strokeColor;
    strokeOpacity.value = props.strokeOpacity;
    strokeWidth.value = props.strokeWidth;
  });
</script>

<template>
  <polyline
    id="props.id"
    :points="points"
    fill="none"
    :stroke="props.strokeColor"
    :stroke-width="props.strokeWidth"
    :stroke-opacity="`${props.strokeOpacity}%`"
  />
</template>